export enum Language {
    Chinese = "Chinese",
    ChineseTraditional = "Chinese_Traditional",
    English = "English",
    French = "French",
    German = "German",
    Italian = "Italian",
    Japanese = "Japanese",
    Korean = "Korean",
    Polish = "Polish",
    Portuguese = "Portuguese",
    Russian = "Russian",
    Spanish = "Spanish",
    Taiwanese = "Taiwanese",
    Thai = "Thai",
    Vietnamese = "Vietnamese",
}
